import { DialogActions, styled } from '@mui/material';

const StyledSessionDetailsDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: `${theme.spacing(1.5)} 0 0`
}));

export default StyledSessionDetailsDialogActions;
